<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-document">  Sample Information All</i>
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-row>
                <el-col :span="24" class="searchbar">
                    <el-col :span="3">
                        <label class="searchtitle">Project</label><br>
                        <el-select v-model="selectprojectvalue" filterable multiple placeholder="请选择">
                            <el-option
                            v-for="item in selectprojectoptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="3">
                        <label class="searchtitle">Country</label><br>
                        <el-select v-model="selectcountryvalue" filterable multiple placeholder="请选择">
                            <el-option
                            v-for="item in selectcountryoptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>                   
                    <el-col :span="3">
                        <label class="searchtitle">Brand</label><br>
                        <el-select v-model="selectbrandvalue" filterable multiple placeholder="请选择">
                            <el-option
                            v-for="item in selectbrandoptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>                   
                    <el-col :span="3">
                        <label class="searchtitle">Progress</label><br>
                        <el-select v-model="selectprogressvalue" filterable placeholder="请选择">
                            <el-option
                            v-for="item in selectprogressoptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>                  
                    <!-- <el-col :span="3">
                        <label class="searchtitle">Outgoing Way</label>
                        <el-select v-model="selectoutgoingwayvalue" filterable placeholder="请选择">
                            <el-option
                            v-for="item in selectoutgoingwayoptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>                   
                    <el-col :span="3">
                        <label class="searchtitle">Material code</label>
                        <el-select v-model="selectmaterialcodevalue" filterable placeholder="请选择">
                            <el-option
                            v-for="item in selectmaterialcodeoptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>                    -->
                    <el-col :span="4">
                        <label class="searchtitle">Send Time</label><br>
                        <el-date-picker
                            style="width:100%;"
                            v-model="selectsendtimevalue"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="Choose Send Time">
                        </el-date-picker>
                    </el-col>
                    <el-col :span="4">
                        <label class="searchtitle">Receive Time</label><br>
                        <el-date-picker
                            style="width:100%;"
                            v-model="selectReceivetimevalue"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="Choose Receive Time">
                        </el-date-picker>
                    </el-col>
                    <el-col :span="4">
                        <label class="searchtitle">Sender</label><br>
                        <el-input v-model="selectsendervalue" placeholder="Please Enter Sender"></el-input>
                    </el-col>                    
                    <!-- <el-col :span="5" style="margin-top:10px;">
                        <label class="searchtitle">BAT information</label>
                        <el-select v-model="selectbatteryvalue" filterable placeholder="请选择">
                            <el-option
                            v-for="item in selectbatteryoptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col> 
                    <el-col :span="5" style="margin-top:10px;">
                        <label class="searchtitle">Department</label>
                        <el-select v-model="selectreplacementcountryvalue" filterable placeholder="请选择">
                            <el-option
                            v-for="item in selectreplacementcountryoptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>  -->
                    <el-col :span="6" style="margin-top:30px;">
                        <el-button size="small" type="success" style="margin-left:5px;" @click="searchSampleInformationAll">S E A R C H</el-button>
                        <el-button size="small" type="info" @click="clearSampleInformationAll">C L E A R</el-button>
                    <el-button size="small" type="warning" icon="el-icon-download" @click="ExportSampleInformationAll">Export All Data</el-button>
                    </el-col>
                </el-col>
                <el-col :span="24">
                  <!--   :data="tableData.slice((currentpage-1)*pagesize,currentpage*pagesize)" -->
                    <el-table
                        ref="SampleInformationAllTable"
                        v-loading="loading"
                        element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)"
                        :data="tableData"
                        border
                        stripe
                        tooltip-effect="dark"
                        style="width: 100%"
                        @selection-change="handleSelectionChange">
                        <!-- <el-table-column
                            type="selection"
                            width="5px">
                        </el-table-column> -->
                        <el-table-column
                            prop="id"
                            label="ID"
                            align="center"
                            v-if="idshow"
                            width="10px">
                        </el-table-column>
                        <el-table-column
                            prop="replacement_countrych"
                            label="Department"
                            align="center"
                            width="170px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="brand"
                            label="Brand"
                            align="center"
                            width="80px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="project"
                            label="Project"
                            align="center"
                            width="80px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="countrych"
                            label="Country"
                            align="center"
                            width="80px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="identify_code"
                            label="Identify Code"
                            align="center"
                            width="130px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="send_number"
                            label="Send Number"
                            align="center"
                            width="120px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="send_time"
                            label="Apply Time"
                            align="center"
                            width="120px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="sender"
                            label="Applyer"
                            align="center"
                            width="80px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="status"
                            label="Status"
                            align="center"
                            width="80px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="has_battery"
                            label="Take Battery"
                            align="center"
                            width="150px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="battery"
                            label="BAT Information"
                            align="center"
                            width="150px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="outgoing_way"
                            label="Outgoing Way"
                            align="center"
                            width="120px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="tracking_number"
                            label="Tracking NO"
                            align="center"
                            width="120px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="progress"
                            label="Progress"
                            align="center"
                            width="90px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="delivery_cost"
                            label="Delivery Cost"
                            align="center"
                            width="130px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <!-- <el-table-column
                            prop="product"
                            label="Product"
                            align="center"
                            width="80px"
                            :show-overflow-tooltip="true">
                        </el-table-column> -->
                        <el-table-column
                            prop="logistics_percent"
                            label="Logistics Percent"
                            align="center"
                            width="140px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <!-- <el-table-column
                            prop="logist_ic"
                            label="LD"
                            align="center"
                            width="120px"
                            :show-overflow-tooltip="true">
                        </el-table-column> -->
                        <el-table-column
                            prop="receive_number1"
                            label="Receive Quantity"
                            align="center"
                            width="150px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="received_time1"
                            label="Receiverd Time"
                            align="center"
                            width="190px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="receiver1"
                            label="Recipient"
                            align="center"
                            width="100px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="receive_number2"
                            label="Transit Sample Quantity"
                            align="center"
                            width="190px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="received_time2"
                            label="Transit Sample recieved time"
                            align="center"
                            width="220px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="receiver2"
                            label="Transit Sample recipient"
                            align="center"
                            width="190px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="OA_code"
                            label="OA Process Number"
                            align="center"
                            width="170px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="material_code"
                            label="Material Code"
                            align="center"
                            width="150px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="material_desc"
                            label="Material Description"
                            align="center"
                            width="160px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="charge_offs"
                            label="Charge-offs"
                            align="center"
                            width="100px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="comment"
                            label="Comment"
                            align="center"
                            width="100px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column 
                            fixed="right"
                            label="Operation"
                            align="center"
                            width="150px">
                            <template slot-scope="scope">
                                <el-button
                                size="mini"
                                v-if="group == 'overseamanager.perm_level_high' || group == 'overseamanager.perm_level_middle'"
                                @click="dialogEditSampleInformationAllVisible = true;handleEdit(scope.$index, scope.row);">Edit</el-button>                                
                                <el-button
                                v-if="group == 'overseamanager.perm_level_high'"
                                size="mini"
                                type="danger"
                                @click="handleDelete(scope.$index, scope.row)">Delete</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-dialog title="EDIT SAMPLE INFORMATION" :visible.sync="dialogEditSampleInformationAllVisible" style="width:120%;margin-top:-50px;margin-left:-100px;">
                        <el-form label-position="left" label-width="150px" class="EditSampleInformationAllForm">
                            <el-col :span="24">
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Brand">
                                        <el-select class="formselect" v-model="EditSampleInformationAllFormbrand" :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest' || group == 'overseamanager.perm_level_middle'" filterable placeholder="请选择" style="width:100%;">
                                            <el-option
                                            v-for="item in selectbrandoptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                        <!-- <el-input v-model="EditSampleInformationAllFormbrand" placeholder="Please Enter Brand"></el-input> -->
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Project">
                                        <el-select class="formselect" v-model="EditSampleInformationAllFormproject" :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest' || group == 'overseamanager.perm_level_middle'" filterable placeholder="请选择" style="width:100%;">
                                            <el-option
                                            v-for="item in selectprojectoptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                        <!-- <el-input v-model="EditSampleInformationAllFormproject" placeholder="Please Enter Project"></el-input> -->
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Country">
                                        <el-select class="formselect" v-model="EditSampleInformationAllFormcountrych" :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest' || group == 'overseamanager.perm_level_middle'" filterable placeholder="请选择" style="width:100%;">
                                            <el-option
                                            v-for="item in selectcountryoptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                        <!-- <el-input v-model="EditSampleInformationAllFormcountrych" placeholder="Please Enter Country"></el-input> -->
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Department">
                                        <el-select class="formselect" v-model="EditSampleInformationAllFormreplacementcountrych" :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest' || group == 'overseamanager.perm_level_middle'" filterable placeholder="请选择" style="width:100%;">
                                            <el-option
                                            v-for="item in selectDepartmentoptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                        <!-- <el-input v-model="EditSampleInformationAllFormreplacementcountrych" placeholder="Please Enter Department"></el-input> -->
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Send Number">
                                        <el-input v-model="EditSampleInformationAllFormsendnumber" :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest' || group == 'overseamanager.perm_level_middle'" placeholder="Please Enter Send Number"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Apply Time">
                                        <el-date-picker
                                            :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest' || group == 'overseamanager.perm_level_middle'"
                                            style="width:100%;"
                                            v-model="EditSampleInformationAllFormsendtime"
                                            type="date"
                                            value-format="yyyy-MM-dd"
                                            placeholder="Choose Apply Time">
                                        </el-date-picker>
                                        <!-- <el-input v-model="EditSampleInformationAllFormsendtime" placeholder="Please Enter Send Time"></el-input> -->
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Applyer">
                                        <el-input v-model="EditSampleInformationAllFormsender" :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest' || group == 'overseamanager.perm_level_middle'" placeholder="Please Enter Applyer"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Status">
                                        <el-select class="formselect" v-model="EditSampleInformationAllFormstatus" :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest' || group == 'overseamanager.perm_level_middle'" filterable placeholder="请选择" style="width:100%;">
                                            <el-option
                                            v-for="item in selectstatusoptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                        <!-- <el-input v-model="EditSampleInformationAllFormstatus" placeholder="Please Enter Status"></el-input> -->
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Has Battery">
                                        <el-radio v-model="EditSampleInformationAllFormhasbattery" :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest' || group == 'overseamanager.perm_level_middle'" @change="EditSampleInformationAllFormbattery=''" label="N">NO</el-radio>
                                        <el-radio v-model="EditSampleInformationAllFormhasbattery" :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest' || group == 'overseamanager.perm_level_middle'" label="Y">YES</el-radio>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol" v-if="EditSampleInformationAllFormhasbattery == 'Y'">
                                    <el-form-item label="BAT Information">
                                        <el-select class="formselect" v-model="EditSampleInformationAllFormbattery" :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest' || group == 'overseamanager.perm_level_middle'" filterable placeholder="请选择" style="width:100%;">
                                            <el-option
                                            v-for="item in selectbatteryoptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                        <!-- <el-input v-model="EditSampleInformationAllFormbattery" placeholder="Please Enter BAT Information"></el-input> -->
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Outgoing Way">
                                        <el-select class="formselect" v-model="EditSampleInformationAllFormoutgoingway" :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest' || group == 'overseamanager.perm_level_middle'" filterable placeholder="请选择" style="width:100%;">
                                            <el-option
                                            v-for="item in selectoutgoingwayoptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                        <!-- <el-input v-model="EditSampleInformationAllFormoutgoingway" placeholder="Please Enter Outgoing Way"></el-input> -->
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Tracking NO">
                                        <el-input v-model="EditSampleInformationAllFormtrackingnumber" :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest' || group == 'overseamanager.perm_level_middle'" placeholder="Please Enter Tracking NO"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Progress">
                                        <el-input v-model="EditSampleInformationAllFormprogress" :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest' || group == 'overseamanager.perm_level_middle'" placeholder="Please Enter Progress"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Delivery Cost">
                                        <el-input v-model="EditSampleInformationAllFormdeliverycost" :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest' || group == 'overseamanager.perm_level_middle'" placeholder="Please Enter Delivery Cost"></el-input>
                                    </el-form-item>
                                </el-col>
                                <!-- <el-col :span="12" class="editcol">
                                    <el-form-item label="Product">
                                        <el-input v-model="EditSampleInformationAllFormproduct" :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest' || group == 'overseamanager.perm_level_middle'" placeholder="Please Enter Product"></el-input>
                                    </el-form-item>
                                </el-col> -->
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Logistics Percent">
                                        <el-select class="formselect" v-model="EditSampleInformationAllFormlogisticspercent" filterable placeholder="Please Select Logistics Percent" style="width:100%;">
                                            <el-option
                                            v-for="item in selectLogisticspercentoptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                        <!-- <el-input v-model="EditSampleInformationAllFormlogisticspercent" placeholder="Please Enter Logistics Percent"></el-input> -->
                                    </el-form-item>
                                </el-col>
                                <!-- <el-col :span="12" class="editcol">
                                    <el-form-item label="LD">
                                        <el-input v-model="EditSampleInformationAllFormlogistic" :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest' || group == 'overseamanager.perm_level_middle'" placeholder="Please Enter LD"></el-input>
                                    </el-form-item>
                                </el-col> -->
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Receive Quantity">
                                        <el-input v-model="EditSampleInformationAllFormreceivenumber1" :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest'" placeholder="Please Enter Receive Quantity"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Received Time 1">
                                        <el-date-picker
                                            style="width:100%;"
                                            v-model="EditSampleInformationAllFormreceivedtime1"
                                            type="date"
                                            :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest' || group == 'overseamanager.perm_level_middle'"
                                            value-format="yyyy-MM-dd"
                                            placeholder="Choose Received Time 1">
                                        </el-date-picker>
                                        <!-- <el-input v-model="EditSampleInformationReceiverFormreceivedtime1" placeholder="Please Enter Receiverd Time"></el-input> -->
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Recipient">
                                        <el-input v-model="EditSampleInformationAllFormreceiver1" :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest' || group == 'overseamanager.perm_level_middle'" placeholder="Please Enter Recipient"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Transit Sample Quantity">
                                        <el-input v-model="EditSampleInformationAllFormreceivenumber2" :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest'" placeholder="Please Enter Transit Sample Quantity"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Received Time 2">
                                        <el-date-picker
                                            style="width:100%;"
                                            :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest' || group == 'overseamanager.perm_level_middle'"
                                            v-model="EditSampleInformationAllFormreceivedtime2"
                                            type="date"
                                            value-format="yyyy-MM-dd"
                                            placeholder="Choose Received Time 2">
                                        </el-date-picker>
                                        <!-- <el-input v-model="EditSampleInformationReceiverFormreceivedtime2" placeholder="Please Enter Transit Sample recieved time"></el-input> -->
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Transit Sample recipient">
                                        <el-input v-model="EditSampleInformationAllFormreceiver2" :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest' || group == 'overseamanager.perm_level_middle'" placeholder="Please Enter Transit Sample recipient"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="OA Process Number">
                                        <el-input v-model="EditSampleInformationAllFormOAcode" :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest'" placeholder="Please Enter OA Process Number"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Material Code">
                                        <el-input v-model="EditSampleInformationAllFormmaterialcode" :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest'" placeholder="Please Enter Material Code"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Material Description">
                                        <el-input v-model="EditSampleInformationAllFormmaterialdesc" :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest'" placeholder="Please Enter Material Description"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Charge-offs">
                                        <el-input v-model="EditSampleInformationAllFormchargeoffs" :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest'" placeholder="Please Enter Charge-offs"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" class="editcol">
                                    <el-form-item label="Comment">
                                        <el-input v-model="EditSampleInformationAllFormcomment" :disabled="group == 'overseamanager.perm_level_low' || group == 'overseamanager.perm_level_lowest'" placeholder="Please Enter Comment"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-col>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="dialogEditSampleInformationAllVisible = false">Cancel</el-button>
                            <el-button type="primary" @click="EditSampleInformationAll">OK</el-button>
                        </div>
                    </el-dialog>
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentpage"
                        :page-sizes="[8, 15, 30, 50]"
                        :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="currentTotal"
                        >
                    </el-pagination>
                </el-col>
            </el-row>
        </div>    
    </div>
</template>

<script>
import { searchSampleInformationAllData,EditSampleInformationAllData,DeleteSampleInformationAllData,GetSampleInformationAllSelectOption,ExportSampleInformationAllData,GetDepartmentSelectOption } from '../../api/index';
export default {
    name: 'basetable',
    data() {
        return {
            group:"",
            currentpage: 1,
            pagesize: 8,
            currentTotal: 0,
            tableData: [],
            multipleSelection: [],
            loading: false,
            idshow: false,
            selectbrandoptions:[],
            selectbrandvalue:[],
            selectstatusoptions:[],
            selectprogressoptions:[],
            selectprogressvalue: '',
            selectbatteryoptions:[],
            selectLogisticspercentoptions:[
                {
                    label: '33.3%',
                    value: '33.3%'
                },
                {
                    label: '50%',
                    value: '50%'
                },
                {
                    label: '100%',
                    value: '100%'
                }
            ],
            selectbatteryvalue: '',
            selectoutgoingwayoptions:[],
            selectoutgoingwayvalue: '',
            selectmaterialcodeoptions:[],
            selectmaterialcodevalue: '',
            selectcountryoptions: [],
            selectcountryvalue: [],
            selectDepartmentoptions: [],
            selectreplacementcountryoptions: [],
            selectreplacementcountryvalue: '',
            selectprojectoptions: [],
            selectprojectvalue: [],
            selectsendervalue:'',
            selectsendtimevalue:'',
            selectReceivetimevalue: '',
            dialogImportSamplesTemplateVisible: false,
            dialogEditSampleInformationAllVisible:false,
            EditSampleInformationAllFormid : "",
            EditSampleInformationAllFormbrand : "",
            EditSampleInformationAllFormproject : "",
            EditSampleInformationAllFormcountrych : "",
            EditSampleInformationAllFormreplacementcountrych : "",
            EditSampleInformationAllFormsendnumber : "",
            EditSampleInformationAllFormsendtime : "",
            EditSampleInformationAllFormsender : "",
            EditSampleInformationAllFormstatus : "",
            EditSampleInformationAllFormhasbattery : "",
            EditSampleInformationAllFormbattery : "",
            EditSampleInformationAllFormoutgoingway : "",
            EditSampleInformationAllFormtrackingnumber : "",
            EditSampleInformationAllFormprogress : "",
            EditSampleInformationAllFormdeliverycost : "",
            // EditSampleInformationAllFormproduct : "",
            EditSampleInformationAllFormlogisticspercent : "",
            // EditSampleInformationAllFormlogistic : "",
            EditSampleInformationAllFormreceivenumber1 : "",
            EditSampleInformationAllFormreceivedtime1 : "",
            EditSampleInformationAllFormreceiver1 : "",
            EditSampleInformationAllFormreceivenumber2 : "",
            EditSampleInformationAllFormreceivedtime2 : "",
            EditSampleInformationAllFormreceiver2 : "",
            EditSampleInformationAllFormOAcode : "",
            EditSampleInformationAllFormmaterialcode : "",
            EditSampleInformationAllFormmaterialdesc : "",
            EditSampleInformationAllFormchargeoffs : "",
            EditSampleInformationAllFormcomment : "",
            ImportSamplesTemplatelimitNum: 1,
            ImportSamplesTemplateform: {
                ImportSamplesTemplatefile: ''
            },
            ImportSamplesTemplatefileList: []
        };
    },
    created() {
        this.group = localStorage.getItem("Group");
        let token = this.$store.getters.idToken;
        searchSampleInformationAllData (1,this.pagesize,{
            project: [],
            countrych: [],
            brand: [],
            replacement_countrych: "",
            send_time: "",
            sender:"",
            progress:"",
            battery:"",
            outgoing_way:"",
            material_code:""
        },token).then(res => {
            console.log(res);
            this.tableData = res.results;
            this.currentTotal = res.count;
        }).catch(error => console.log(error));
        GetSampleInformationAllSelectOption (token).then(res => {
            this.selectbrandoptions = res.brand;
            this.selectprogressoptions = res.progress;
            this.selectstatusoptions = res.status;
            this.selectbatteryoptions = res.battery;
            this.selectoutgoingwayoptions = res.outgoing_way;
            this.selectcountryoptions = res.countrych;
            this.selectreplacementcountryoptions = res.countrych;
            this.selectprojectoptions = res.project;
            this.selectmaterialcodeoptions = res.material_code;
        }).catch(error => console.log(error));
        GetDepartmentSelectOption (token).then(res => {
            this.selectDepartmentoptions = res.department;
        }).catch(error => console.log(error));
    },
    methods: {        
        handleSizeChange(val) {
            this.pagesize = val;
            console.log(`每页 ${val} 条`);
            let token = this.$store.getters.idToken;
        searchSampleInformationAllData (this.currentpage,val,{
          project: this.selectprojectvalue,
                countrych: this.selectcountryvalue,
                brand: this.selectbrandvalue,
                replacement_countrych: this.selectreplacementcountryvalue,
                send_time: this.selectsendtimevalue,
                sender:this.selectsendervalue,
                received_time1: this.selectReceivetimevalue,
                progress:this.selectprogressvalue,
                battery:this.selectbatteryvalue,
                outgoing_way:this.selectoutgoingwayvalue,
                material_code:this.selectmaterialcodevalue
        },token).then(res => {
            console.log(res);
            this.tableData = res.results;
            this.currentTotal = res.count;
        }).catch(error => console.log(error));
        },
        handleCurrentChange(val) {
            this.currentpage = val;
            console.log(`当前页: ${val}`);
            let token = this.$store.getters.idToken;
        searchSampleInformationAllData (val,this.pagesize,{
          project: this.selectprojectvalue,
                countrych: this.selectcountryvalue,
                brand: this.selectbrandvalue,
                replacement_countrych: this.selectreplacementcountryvalue,
                send_time: this.selectsendtimevalue,
                sender:this.selectsendervalue,
                received_time1: this.selectReceivetimevalue,
                progress:this.selectprogressvalue,
                battery:this.selectbatteryvalue,
                outgoing_way:this.selectoutgoingwayvalue,
                material_code:this.selectmaterialcodevalue
        },token).then(res => {
            console.log(res);
            this.tableData = res.results;
            this.currentTotal = res.count;
        }).catch(error => console.log(error));
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            console.log(this.multipleSelection);
        },
        handleEdit(index, row) {
            console.log(index, row);
            this.EditSampleInformationAllFormid = row.id;
            this.EditSampleInformationAllFormbrand = row.brand;
            this.EditSampleInformationAllFormproject = row.project;
            this.EditSampleInformationAllFormcountrych = row.countrych;
            this.EditSampleInformationAllFormreplacementcountrych = row.replacement_countrych;
            this.EditSampleInformationAllFormsendnumber = row.send_number;
            this.EditSampleInformationAllFormsendtime = row.send_time;
            this.EditSampleInformationAllFormsender = row.sender;
            this.EditSampleInformationAllFormstatus = row.status;
            this.EditSampleInformationAllFormhasbattery = row.has_battery;
            this.EditSampleInformationAllFormbattery = row.battery;
            this.EditSampleInformationAllFormoutgoingway = row.outgoing_way;
            this.EditSampleInformationAllFormtrackingnumber = row.tracking_number;
            this.EditSampleInformationAllFormprogress = row.progress;
            this.EditSampleInformationAllFormdeliverycost = row.delivery_cost;
            // this.EditSampleInformationAllFormproduct = row.product;
            this.EditSampleInformationAllFormlogisticspercent = row.logistics_percent;
            // this.EditSampleInformationAllFormlogistic = row.logist_ic;
            this.EditSampleInformationAllFormreceivenumber1 = row.receive_number1;
            this.EditSampleInformationAllFormreceivedtime1 = row.received_time1;
            this.EditSampleInformationAllFormreceiver1 = row.receiver1;
            this.EditSampleInformationAllFormreceivenumber2 = row.receive_number2;
            this.EditSampleInformationAllFormreceivedtime2 = row.received_time2;
            this.EditSampleInformationAllFormreceiver2 = row.receiver2;
            this.EditSampleInformationAllFormOAcode = row.OA_code
            this.EditSampleInformationAllFormmaterialcode = row.material_code
            this.EditSampleInformationAllFormmaterialdesc = row.material_desc
            this.EditSampleInformationAllFormchargeoffs = row.charge_offs
            this.EditSampleInformationAllFormcomment = row.comment
        },
        handleDelete(index, row) {
            let token = this.$store.getters.idToken;
            console.log(index, row);
            console.log(row.id);
            this.$confirm('此Operation将永久Delete该文件, 是否继续?', '提示', {
                confirmButtonText: 'OK',
                cancelButtonText: 'cancel',
                type: 'warning'
            }).then(() => {
                DeleteSampleInformationAllData ({
                    id: row.id
                },token).then(res => {
                    console.log(res);
                    this.tableData.splice(((this.currentpage-1)*this.pagesize+index), 1);
                    this.currentTotal--;
                    this.$message({
                        type: 'success',
                        message: 'Delete successful'
                    });
                    GetSampleInformationAllSelectOption (token).then(res => {
                        this.selectbrandoptions = res.brand;
                        this.selectprogressoptions = res.progress;
                        this.selectstatusoptions = res.status;
                        this.selectbatteryoptions = res.battery;
                        this.selectoutgoingwayoptions = res.outgoing_way;
                        this.selectcountryoptions = res.countrych;
                        this.selectreplacementcountryoptions = res.countrych;
                        this.selectprojectoptions = res.project;
                        this.selectmaterialcodeoptions = res.material_code;
                    }).catch(error => console.log(error));
                }).catch(error => console.log(error));
            }).catch(() => {
                this.$message({
                    type: 'warning',
                    message: 'Delete canceled'
                });          
            });            
        },
        searchSampleInformationAll () {
            let token = this.$store.getters.idToken;
            this.loading = true;
            this.currentpage = 1;
            searchSampleInformationAllData (1,this.pagesize,{
                project: this.selectprojectvalue,
                countrych: this.selectcountryvalue,
                brand: this.selectbrandvalue,
                replacement_countrych: this.selectreplacementcountryvalue,
                send_time: this.selectsendtimevalue,
                sender:this.selectsendervalue,
                received_time1: this.selectReceivetimevalue,
                progress:this.selectprogressvalue,
                battery:this.selectbatteryvalue,
                outgoing_way:this.selectoutgoingwayvalue,
                material_code:this.selectmaterialcodevalue
            },token).then(res => {
                this.tableData = res.results;
                this.currentTotal = res.count;
                this.loading = false;
            }).catch(error => console.log(error));
            GetSampleInformationAllSelectOption (token).then(res => {
                this.selectbrandoptions = res.brand;
                this.selectprogressoptions = res.progress;
                this.selectstatusoptions = res.status;
                this.selectbatteryoptions = res.battery;
                this.selectoutgoingwayoptions = res.outgoing_way;
                this.selectcountryoptions = res.countrych;
                this.selectreplacementcountryoptions = res.countrych;
                this.selectprojectoptions = res.project;
                this.selectmaterialcodeoptions = res.material_code;
            }).catch(error => console.log(error));
        },
        clearSampleInformationAll () {
            let token = this.$store.getters.idToken;
            this.selectprojectvalue = [];
            this.selectcountryvalue = [];
            this.selectbrandvalue = [];
            this.selectprogressvalue = "";
            this.selectreplacementcountryvalue = "";
            this.selectsendtimevalue = "";
            this.selectReceivetimevalue = "";
            this.currentpage = 1;
            searchSampleInformationAllData (1,this.pagesize,{
                project: [],
                countrych: [],
                brand: [],
                replacement_countrych: "",
                send_time: "",
                sender:"",
                received_time1:"",
                progress:"",
                battery:"",
                outgoing_way:"",
                material_code:""
            },token).then(res => {
                this.tableData = res.results;
                this.currentTotal = res.count;
                this.loading = false;
            }).catch(error => console.log(error));
            GetSampleInformationAllSelectOption (token).then(res => {
                this.selectbrandoptions = res.brand;
                this.selectprogressoptions = res.progress;
                this.selectstatusoptions = res.status;
                this.selectbatteryoptions = res.battery;
                this.selectoutgoingwayoptions = res.outgoing_way;
                this.selectcountryoptions = res.countrych;
                this.selectreplacementcountryoptions = res.countrych;
                this.selectprojectoptions = res.project;
                this.selectmaterialcodeoptions = res.material_code;
            }).catch(error => console.log(error));
        },
        EditSampleInformationAll() {
            let token = this.$store.getters.idToken;
            const EditSampleInformationAllFormData = {
                id: this.EditSampleInformationAllFormid,
                brand: this.EditSampleInformationAllFormbrand,
                project: this.EditSampleInformationAllFormproject,
                countrych: this.EditSampleInformationAllFormcountrych,
                replacement_countrych: this.EditSampleInformationAllFormreplacementcountrych,
                send_number: this.EditSampleInformationAllFormsendnumber,
                send_time: this.EditSampleInformationAllFormsendtime,
                sender: this.EditSampleInformationAllFormsender,
                status: this.EditSampleInformationAllFormstatus,
                has_battery: this.EditSampleInformationAllFormhasbattery,
                battery: this.EditSampleInformationAllFormbattery,
                outgoing_way: this.EditSampleInformationAllFormoutgoingway,
                tracking_number: this.EditSampleInformationAllFormtrackingnumber,
                progress: this.EditSampleInformationAllFormprogress,
                delivery_cost: this.EditSampleInformationAllFormdeliverycost,
                product: 'P',
                // product: this.EditSampleInformationAllFormproduct,
                logistics_percent: this.EditSampleInformationAllFormlogisticspercent,
                logist_ic: 'Admin',
                // logist_ic: this.EditSampleInformationAllFormlogistic,
                receive_number1: this.EditSampleInformationAllFormreceivenumber1,
                received_time1: this.EditSampleInformationAllFormreceivedtime1,
                receiver1: this.EditSampleInformationAllFormreceiver1,
                receive_number2: this.EditSampleInformationAllFormreceivenumber2,
                received_time2: this.EditSampleInformationAllFormreceivedtime2,
                receiver2: this.EditSampleInformationAllFormreceiver2,
                OA_code: this.EditSampleInformationAllFormOAcode,
                material_code: this.EditSampleInformationAllFormmaterialcode,
                material_desc: this.EditSampleInformationAllFormmaterialdesc,
                charge_offs: this.EditSampleInformationAllFormchargeoffs,
                comment: this.EditSampleInformationAllFormcomment,
            }
            EditSampleInformationAllData (this.EditSampleInformationAllFormid,EditSampleInformationAllFormData,token).then(res => {
                if (res.code == 1) {
                    this.$message({
                        message: '恭喜你，Modified successfully',
                        type: 'success'
                    });
                    for (var i = 0;i < this.tableData.length;i++) {
                        if (this.EditSampleInformationAllFormid == this.tableData[i].id) {
                            this.tableData[i].brand = EditSampleInformationAllFormData.brand;
                            this.tableData[i].project = EditSampleInformationAllFormData.project;
                            this.tableData[i].countrych = EditSampleInformationAllFormData.countrych;
                            this.tableData[i].replacement_countrych = EditSampleInformationAllFormData.replacement_countrych;
                            this.tableData[i].send_number = EditSampleInformationAllFormData.send_number;
                            this.tableData[i].send_time = EditSampleInformationAllFormData.send_time;
                            this.tableData[i].sender = EditSampleInformationAllFormData.sender;
                            this.tableData[i].status = EditSampleInformationAllFormData.status;
                            this.tableData[i].has_battery = EditSampleInformationAllFormData.has_battery;
                            this.tableData[i].battery = EditSampleInformationAllFormData.battery;
                            this.tableData[i].outgoing_way = EditSampleInformationAllFormData.outgoing_way;
                            this.tableData[i].tracking_number = EditSampleInformationAllFormData.tracking_number;
                            this.tableData[i].progress = EditSampleInformationAllFormData.progress;
                            this.tableData[i].delivery_cost = EditSampleInformationAllFormData.delivery_cost;
                            // this.tableData[i].product = EditSampleInformationAllFormData.product;
                            this.tableData[i].logistics_percent = EditSampleInformationAllFormData.logistics_percent;
                            // this.tableData[i].logist_ic = EditSampleInformationAllFormData.logist_ic;
                            this.tableData[i].receive_number1 = EditSampleInformationAllFormData.receivenumber1;
                            this.tableData[i].received_time1 = EditSampleInformationAllFormData.receivedtime1;
                            this.tableData[i].receiver1 = EditSampleInformationAllFormData.receiver1;
                            this.tableData[i].receive_number2 = EditSampleInformationAllFormData.receivenumber2;
                            this.tableData[i].received_time2 = EditSampleInformationAllFormData.receivedtime2;
                            this.tableData[i].receiver2 = EditSampleInformationAllFormData.receiver2;
                            this.tableData[i].OA_code = EditSampleInformationAllFormData.OA_code;
                            this.tableData[i].material_code = EditSampleInformationAllFormData.material_code;
                            this.tableData[i].material_desc = EditSampleInformationAllFormData.material_desc;
                            this.tableData[i].charge_offs = EditSampleInformationAllFormData.charge_offs;
                            this.tableData[i].comment = EditSampleInformationAllFormData.comment;
                            console.log(this.tableData[i]);
                        }
                    }
                    GetSampleInformationAllSelectOption (token).then(res => {
                        this.selectbrandoptions = res.brand;
                        this.selectprogressoptions = res.progress;
                        this.selectstatusoptions = res.status;
                        this.selectbatteryoptions = res.battery;
                        this.selectoutgoingwayoptions = res.outgoing_way;
                        this.selectcountryoptions = res.countrych;
                        this.selectreplacementcountryoptions = res.countrych;
                        this.selectprojectoptions = res.project;
                        this.selectmaterialcodeoptions = res.material_code;
                    }).catch(error => console.log(error));
                    this.dialogEditSampleInformationAllVisible = false;
                    // this.$router.push({path:'/SampleInformationAll'});
                }else {
                    this.$message({
                        type: 'warning',
                        message: res.msg
                    });   
                }
            }).catch(error => {
                this.$message({
                    type: 'warning',
                    message: error.msg
                });        
            });  
            // .catch(error => console.log(error));  
        },
        ExportSampleInformationAll() {
            let token = this.$store.getters.idToken;
            const loading = this.$loading({
                lock: true,
                text: 'Exporting',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            ExportSampleInformationAllData ({
                project: this.selectprojectvalue,
                countrych: this.selectcountryvalue,
                brand: this.selectbrandvalue,
                replacement_countrych: this.selectreplacementcountryvalue,
                send_time: this.selectsendtimevalue,
                sender:this.selectsendervalue,
                received_time1: this.selectReceivetimevalue,
                progress:this.selectprogressvalue,
                battery:this.selectbatteryvalue,
                outgoing_way:this.selectoutgoingwayvalue,
                material_code:this.selectmaterialcodevalue,
            },token).then(res => {
                // console.log(res);
                if(res.code == 1) {
                    this.$message({
                        type: 'success',
                        message: 'Export Success!'
                    });
                    window.location.href = res.url;
                    loading.close();
                }else {
                    this.$message({
                        type: 'warning',
                        message: 'Export Failed!'
                    });
                    loading.close();
                }                    
            }).catch(error => console.log(error));     
        },
    }
};
</script>

<style scoped>
    .searchtitle {
        font-family: Arial, Helvetica, sans-serif;
        font-weight: bold;
        font-size: 16px;
        margin-right: 10px;
    }
    .searchbar {
        padding: 20px 0px;
        margin-top:-30px;
    }
    .AddNewSampleInformationAllForm {
        font-weight: bold;
        font-size: 16px;
    }
    .editcol {
        padding: 0 10px;
    }
</style>
